// src/redux/slices/accountSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  accountInfo: null,
};

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setAccountInfo: (state, action) => {
      state.accountInfo = action.payload;
    },
    clearAccountInfo: (state) => {
      state.accountInfo = null;
    },
  },
});

export const { setAccountInfo, clearAccountInfo } = accountSlice.actions;

export default accountSlice.reducer;
